import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const BlockedProductsPreviewSkeleton = () => {
  return (
    <Styles.Container>
      <Styles.PreviewContent>
        <Styles.SelectorContainer>
          <Styles.LineItemContainer>
            <Styles.IsReturnableMessage>
              <Styles.ErrorTitle>
                <Skeleton variant="rounded" width={24} height={24} />
                <Skeleton variant="text" width={160} height={18} />
              </Styles.ErrorTitle>
              <Skeleton variant="text" width="90%" height={14} />
            </Styles.IsReturnableMessage>
            <Styles.ProductRow>
              <Skeleton variant="rounded" width={108} height={108} />
              <Styles.ProductInfo>
                <Skeleton variant="text" width="80%" height={16} />
                <Skeleton variant="text" width="50%" height={14} />
                <Skeleton variant="text" width="40%" height={14} />
              </Styles.ProductInfo>
            </Styles.ProductRow>
          </Styles.LineItemContainer>
        </Styles.SelectorContainer>
      </Styles.PreviewContent>
    </Styles.Container>
  )
}

export default BlockedProductsPreviewSkeleton
